import { render, staticRenderFns } from "./HeaderLanguageDropdown.vue?vue&type=template&id=26647bba&"
import script from "./HeaderLanguageDropdown.vue?vue&type=script&lang=js&"
export * from "./HeaderLanguageDropdown.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLanguageDropdown.vue?vue&type=style&index=0&id=26647bba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports